import React,{ useEffect, useState }  from 'react';
import { Table } from "antd";
import Header from '../Header';
import Sidebar from '../Sidebar';
import {onShowSizeChange,itemRender}from  '../Pagination'
import { blogimg10, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal, blogimg12,
     blogimg2, blogimg4, blogimg6, blogimg8,
     male,
     female} from '../imagepath';
import { Link } from 'react-router-dom';
import { Feather } from 'feather-icons-react/build/IconComponents';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import Password from 'antd/es/input/Password';
import { getPharmacist } from '../../services/doctor/pharmacies/pharmacies';

const PharmacistList = () => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);


    const fetchPharmacist = async () => {
      try {
        const result = await getPharmacist();
        if (result.success) {
          console.log("Fetched Data:", result.data);
          const formattedData = result.data.map((item, index) => ({
            id: item.id || index,
            parentId: item.parent_user_id,
            Name: item.name,
            middlename: item.middle_name,
            lastname: item.last_name,
            Email: item.email,
            Password: item.password || "N/A",
            mobile: item.mobile || "-",
            aadhaar_card_number: item.aadhaar_card_number || "N/A",
            date_of_birth: item.date_of_birth,
            gender: item.gender,
            address: item.address,
            city: item.city,
            state: item.state,
            country: item.country,
            pincode: item.pincode,
            status:item.status,
            
          }));
          console.log("Formatted Data:", formattedData);
          setDataSource(formattedData);
        } else {
          console.error("Error:", result.error || "Failed to fetch hospitals");
        }
      } catch (err) {
        console.error("Exception:", err.message);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchPharmacist();
    }, []);

    const onSelectChange = (newSelectedRowKeys) => {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const columns = [
      {
          title: "Name",
          dataIndex: "Name",
          render: (text, record) => (
              <>
                  <h2 className="profile-image">
                      <Link to="#" className="avatar avatar-sm me-2">
                          
                          
                            <img
                              className="avatar-img rounded-circle"
                              src={record.gender == "male" ? male : female}
                              alt="User Image"
                          />
                      </Link>
                      <Link to="#">{record.Name}  {record.lastname}</Link>
                  </h2>

              </>
          ),
          // sorter: (a, b) => a.Name.length - b.Name.length
      },
      
      {
          title:"Mobile",
          dataIndex: "Mobile",
              // sorter: (a, b) => a.Mobile.length - b.Mobile.length,
              render: (text, record) => (
                  <>
                          <Link to="#">{record.mobile}</Link>
                  </>
              )
      }, {
          title:"Email",
          dataIndex: "Email",
              // sorter: (a, b) => a.Email.length - b.Email.length
      },
      //  {
      //     title:"Hospital",
      //     dataIndex: "hospital",
      //         sorter: (a, b) => a.Email.length - b.Email.length
      // },
       {
          title:"Status",
          dataIndex: "status",
              // sorter: (a, b) => a.Email.length - b.Email.length
      },

      {
        title: "",
        dataIndex: "FIELD8",
        render: (text, record) => (
          <>
            <div className="text-end">
              <div className="dropdown dropdown-action">
                <Link
                  to="#"
                  className="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-ellipsis-v" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  {/* <Link className="dropdown-item" to="/pharmacistprofile  " state={{ pharmacist: record }}>
                    <i className="fa-solid fa-user-doctor me-2" />
                    View Profile
                  </Link> */}
                  <Link className="dropdown-item" to="/edit-pharmacist" state={{ pharmacist: record }}>
                    <i className="far fa-edit me-2" />
                    Edit
                  </Link>
                  <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_patient">
                     <i className="fa fa-trash-alt m-r-5"></i> Delete</Link>
                </div>
              </div>
            </div>
          </>
        ),
      },
  ]
  useEffect(() => {
        const sidebar = document.getElementById("sidebar");
        if (sidebar) {
          sidebar.classList.add("sidebar-doctor");
          sidebar.id = "menu-item1"; // Change ID if needed
        }
        document.body.classList.remove("expand-menu");
      
            document.body.classList.add("mini-sidebar");
      }, []);


  return (
    <>
      <Sidebar
        activeClassName="pharmacistlist"
      />  
      <div className="page-wrapper-doctor">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/pharmacistlist">Pharmacist </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right" />
                    <FeatherIcon icon="chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">Pharmacist List</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Pharmaciest List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </form>
                            </div>
                            <div className="add-group">
                              <Link
                                to="/add-pharmacist"
                                className="btn btn-primary add-pluss ms-2"
                              >
                                <img src={plusicon} alt="#" />
                              </Link>
                              <Link
                                to="#"
                                className="btn btn-primary doctor-refresh ms-2"
                              >
                                <img src={refreshicon} alt="#" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="table-responsive doctor-list">
                    <Table
                      pagination={{
                        total: dataSource.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        // showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                        style: { paddingRight: "14px" },
                      }}
                      columns={columns}
                      loading={loading}
                      dataSource={dataSource}
                      rowSelection={rowSelection}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="delete_patient"
        className="modal fade delete-modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to delete this ?</h3>
              <div className="m-t-20">
                {" "}
                <Link
                  to="#"
                  className="btn btn-white me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button type="submit" className="btn btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PharmacistList;
